import React, { useEffect, useState } from "react";
import Slide from '@mui/material/Slide';
import { Dialog, DialogTitle, DialogActions, Button, DialogContent, Typography, FormLabel, RadioGroup, FormControl, FormControlLabel, Radio, Autocomplete, TextField, Grid, MenuItem, Tooltip, Box, Alert } from "@mui/material";
import corporateService from "app/services/corporate";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { array, boolean, number, object, string, mixed } from "yup"
import { Formik, Form, getIn, FieldArray } from 'formik'
import SwitchField from "app/components/SwitchField";
import { useQuery } from "@tanstack/react-query";
const MySwal = withReactContent(Swal);
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});



const BeneficiaryPreApprovalModal = ({ open, handleClose, beneficiaryId, name }) => {
    const [initialValues, setInitialValues] = useState({
        vouchers: []
    })

    const { data, isError, isFetching, isLoading, refetch } =
        useQuery(
            ['voucher-benefiary-data'],
            async () => {
                const axiosData = await corporateService.getBeneficiaryVouchers(beneficiaryId)
                setInitialValues({ ...initialValues, vouchers: axiosData })
                return axiosData;
            },
            { keepPreviousData: false, enabled: !!beneficiaryId },
        );
    useEffect(() => {
    }, []);


    return (
        <Dialog
            open={true}
            TransitionComponent={Transition}
            keepMounted
            onClose={handleClose}
            aria-describedby="alert-dialog-slide-description"
            fullWidth
            maxWidth={'md'}
        >
            <Formik
                validateOnChange={true}
                initialValues={initialValues}
                validationSchema={object({
                    vouchers: array(
                        object(
                            {
                                voucher_id: number().required('Voucher Obrigatório'),
                                pre_approved: string()
                                    .when("checked", (value) => {
                                        if (value === 1) {
                                            return string().required("Obrigatório")

                                        }

                                    })

                            }
                        )
                    )

                })}
                enableReinitialize
                onSubmit={(data, { setSubmitting }) => {
                    corporateService.updateBeneficiaryVouchers(beneficiaryId, data).then(() => {
                        handleClose();
                        Swal.fire(
                            'Sucesso!',
                            'Actualizado com sucesso!',
                            'success'
                        )
                    })
                }}
            >
                {({ values, touched, errors, handleChange, handleBlur, isValid, setFieldValue }) => (
                    <Form style={{ textAlign: 'left' }} noValidate autoComplete='off' id="pre-approval-form">
                        <DialogTitle>Editar Beneficiário -{beneficiaryId} - {name}</DialogTitle>
                        <DialogContent>
                            <Box mb={2} />
                            <FieldArray name="vouchers">
                                {({ push, remove }) => (
                                    <div>

                                        {values?.vouchers?.map((_voucher, index) => {
                                            const voucher = `vouchers[${index}].voucher_id`;
                                            const touchedVoucher = getIn(touched, voucher);
                                            const errorVoucher = getIn(errors, voucher);
                                            const checked = `vouchers[${index}].checked`;

                                            const preApproved = `vouchers[${index}].pre_approved`;
                                            const touchedPreApproved = getIn(touched, preApproved);
                                            const errorPreApproved = getIn(errors, preApproved);

                                            return (
                                                <Grid container spacing={4} key={index} mb={1}>
                                                    <Grid item xs={5}>
                                                        <TextField
                                                            size='small'
                                                            fullWidth variant="outlined"
                                                            name={voucher}
                                                            defaultValue=''
                                                            value={_voucher.name}
                                                            onBlur={handleBlur}
                                                            label="Voucher"
                                                            helperText={
                                                                touchedVoucher && errorVoucher
                                                                    ? errorVoucher
                                                                    : ""
                                                            }
                                                            error={Boolean(touchedVoucher && errorVoucher)}
                                                        />
                                                    </Grid>
                                                    <Grid item xs={5}>
                                                        <TextField
                                                            size='small'
                                                            type="number"
                                                            fullWidth variant="outlined"
                                                            name={preApproved}
                                                            defaultValue=''
                                                            value={_voucher.pre_approved}
                                                            onChange={handleChange}
                                                            onBlur={handleBlur}
                                                            label="Pre-Aprovados"
                                                            helperText={
                                                                touchedPreApproved && errorPreApproved
                                                                    ? errorPreApproved
                                                                    : ""
                                                            }
                                                            inputProps={{
                                                                min: 0,
                                                                max: 100,
                                                            }}
                                                            error={Boolean(touchedPreApproved && errorPreApproved)}

                                                        />
                                                    </Grid>
                                                    <Grid item xs={2}>
                                                        <SwitchField
                                                            name={checked}
                                                            value={_voucher.checked}
                                                            onChange={(e, v) => {
                                                                setFieldValue(checked, e.target.value)
                                                                setFieldValue(preApproved, '')
                                                            }}
                                                            color="primary"
                                                        />
                                                    </Grid>
                                                </Grid>
                                            );
                                        })}
                                    </div>
                                )}
                            </FieldArray>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={handleClose}>Cancelar</Button>
                            <Button type="submit" form="pre-approval-form">Gravar</Button>
                        </DialogActions>
                    </Form>
                )}
            </Formik>
        </Dialog>
    )

}

export default BeneficiaryPreApprovalModal;